import { CalendarEventFormFields } from '@griply/types';

import { DEFAULT_CALENDAR_EVENT_DURATION_MS } from './build-calendar-event-form-fields';

// Each setter returns only the fields it coerces, so a caller can spread the result straight
// into its form update. Moving one boundary past the other drags the other along instead of
// inverting the span — a backwards event is the one shape the providers reject outright.

const FALLBACK_START_TIME_MS = 9 * 60 * 60 * 1000;

// Without the restore, an event that never carried times turns into an invalid midnight block.
export const setCalendarEventAllDay = (
  fields: CalendarEventFormFields,
  allDay: boolean,
): Partial<CalendarEventFormFields> => {
  if (allDay) {
    return { allDay: true };
  }

  const startTime = fields.startTime ?? FALLBACK_START_TIME_MS;

  return {
    allDay: false,
    startTime,
    endTime: fields.endTime ?? startTime + DEFAULT_CALENDAR_EVENT_DURATION_MS,
  };
};

export const setCalendarEventStartDate = (
  fields: CalendarEventFormFields,
  startDate: Date,
): Partial<CalendarEventFormFields> => ({
  startDate,
  endDate: fields.endDate < startDate ? startDate : fields.endDate,
});

export const setCalendarEventEndDate = (
  fields: CalendarEventFormFields,
  endDate: Date,
): Partial<CalendarEventFormFields> => ({
  endDate: endDate < fields.startDate ? fields.startDate : endDate,
});

export const setCalendarEventStartTime = (
  fields: CalendarEventFormFields,
  startTime: number,
): Partial<CalendarEventFormFields> => {
  const sameDay = fields.startDate.getTime() === fields.endDate.getTime();
  const endTime =
    sameDay && fields.endTime !== null && fields.endTime <= startTime
      ? startTime + DEFAULT_CALENDAR_EVENT_DURATION_MS
      : fields.endTime;

  return { startTime, endTime };
};
